import React, { useEffect, useState } from 'react';
import { formatDateTime, isValidDateValue } from '../counter';
import './DeadlineCountdown.css';

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const pad = value => String(value).padStart(2, '0');

const formatRemaining = ms => {
  const days = Math.floor(ms / DAY);
  const hours = Math.floor((ms % DAY) / HOUR);
  const minutes = Math.floor((ms % HOUR) / MINUTE);
  if (days > 0) return `${days}d ${pad(hours)}h ${pad(minutes)}m`;
  if (hours > 0) return `${hours}h ${pad(minutes)}m`;
  return `${Math.max(minutes, 1)}m`;
};

const getTone = ms => {
  if (ms <= 0) return 'closed';
  if (ms < DAY) return 'urgent';
  if (ms < 3 * DAY) return 'soon';
  return 'ok';
};

const DeadlineCountdown = ({
  deadline,
  dateLabel,
  openLabel = 'Closes in',
  closedLabel = 'Closed',
  compact = false,
}) => {
  const [now, setNow] = useState(() => Date.now());
  const isValid = isValidDateValue(deadline);

  useEffect(() => {
    if (!isValid) return undefined;
    const timer = setInterval(() => setNow(Date.now()), 30 * 1000);
    return () => clearInterval(timer);
  }, [isValid]);

  if (!isValid) return null;

  const remaining = new Date(deadline).getTime() - now;
  const tone = getTone(remaining);
  const isClosed = tone === 'closed';
  const className = [
    'ic-deadline',
    `ic-deadline--${tone}`,
    compact ? 'ic-deadline--compact' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={className} role='timer'>
      {!compact ? (
        <span className='ic-deadline__icon' aria-hidden='true'>
          <i className={isClosed ? 'ri-lock-line' : 'ri-timer-flash-line'} />
        </span>
      ) : null}
      <div style={{ minWidth: 0 }}>
        <span className='ic-deadline__label'>
          {isClosed ? closedLabel : openLabel}
        </span>
        <span className='ic-deadline__value'>
          {isClosed ? 'Closed' : formatRemaining(remaining)}
        </span>
        <span className='ic-deadline__date'>
          {compact
            ? formatDateTime(deadline)
            : `${dateLabel ? `${dateLabel}: ` : ''}${formatDateTime(deadline)} (Jakarta time)`}
        </span>
      </div>
    </div>
  );
};

export const DateCountdown = ({
  label,
  deadline,
  openLabel,
  closedLabel,
  compact = false,
}) => (
  <DeadlineCountdown
    deadline={deadline}
    dateLabel={label}
    openLabel={openLabel}
    closedLabel={closedLabel}
    compact={compact}
  />
);

export default DeadlineCountdown;
